import { render, staticRenderFns } from "./StarPill.vue?vue&type=template&id=32fd3c7d"
import script from "./StarPill.vue?vue&type=script&lang=js"
export * from "./StarPill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports